"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogIndex = void 0;
var constants_1 = require("@ethersproject/constants");
exports.getLogIndex = function (transactionReceipt, logEventSig) {
    // Check topics[0] to find a transfer of the correct asset type e.g. ERC20
    // Check topics[2] to filter out any transfers previous to the burn i.e. those not to the zero address
    var logIndex = transactionReceipt.logs.findIndex(function (log) { return log.topics[0].toLowerCase() === logEventSig.toLowerCase() && log.topics[2].toLowerCase() === constants_1.HashZero; });
    if (logIndex === -1) {
        throw new Error("Burn log not found in receipt");
    }
    return logIndex;
};
